import getButtonStyles from "@/lib/helpers/getButtonStyles";
import useFocus from "@/lib/hooks/interactions/other/useFocus";
import { ButtonLinkPropsType, useHover } from "@/lib/main";
import { NavLink } from "react-router";

export default function ButtonNavLink({
  anchorRef,
  children,
  className,
  disabled,
  fullWidth,
  id,
  onClick,
  to,
  color,
  size,
  style,
}: ButtonLinkPropsType) {
  if (!color) color = "outlined";
  if (!size) size = "md";

  const { isFocused, onFocus, onBlur } = useFocus();
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();

  const defaultStyle = getButtonStyles({
    color,
    disabled,
    fullWidth,
    isFocused,
    isHovered,
    size,
  });

  const styles = {
    ...defaultStyle,
    ...style,
    ...(disabled
      ? {
          pointerEvents: "none" as const,
        }
      : {}),
  };

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    onClick?.(event);
  };

  return (
    <NavLink
      to={to}
      aria-disabled={disabled || undefined}
      className={className}
      id={id}
      onClick={handleClick}
      onFocus={onFocus}
      onBlur={onBlur}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={styles}
      tabIndex={disabled ? -1 : undefined}
      ref={anchorRef}
    >
      {children}
    </NavLink>
  );
}
